import { axios } from "@/plugins/axios"
import store from "@/store"
import { app } from "@/main"

export async function getMainfiles() {
  const mainfileApi = "/system/mainfiles";
  let mainfiles = []

  await axios
    .get(mainfileApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.mainfiles != undefined) {
        mainfiles = response.data.mainfiles
      }
    })

  return mainfiles
}

export async function addMainfile(data) {
  const mainfileApi = "/system/mainfile";

  await axios
    .post(mainfileApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("mainfileNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function updateMainfile(data) {
  const mainfileApi = "/system/mainfile";

  await axios
    .put(mainfileApi, data)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("mainfileNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function removeMainfiles(data) {
  const mainfileApi = "/system/mainfiles";

  await axios
    .delete(mainfileApi, { data: data })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function importMainfilesFromCsv(csvFile) {
  const mainfileApi = "/system/mainfiles/data";

  const data = new FormData();
  data.append("file", csvFile);

  await axios
    .post(mainfileApi, data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("mainfileNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    });
}

export async function exportMainfilesFromCsv() {
  const mainfileApi = "/system/mainfiles/data";

  await axios
    .get(mainfileApi)
    .catch((error) => {
      if (error.response.data.status == undefined) {
        store.dispatch("openSnackbar", {
          message: app.$t("systemNetworkError"),
        });
      } else {
        store.dispatch("openSnackbar", {
          message: error.response.data.status.message,
        });
      }
      throw (error)
    })
    .then((response) => {
      if (response.data.mainfiles != undefined) {
        let mainfiles = response.data.mainfiles;

        let blob = new Blob([mainfiles], {
          type: "text/csv",
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        let fileName = "mainfile.csv";
        link.download = fileName;
        link.click();
      }
    })
}